/*
 * @Description: 权限指令
 */
import { Directive, DirectiveBinding } from "vue"
import { useUserInfo } from "@/store"
import { getOpList } from "@/data/permission"

export const permission: Directive = {
  async mounted(el: HTMLDivElement, binding: DirectiveBinding) {
    const userStore = useUserInfo()
    // 只有在用户信息不存在时才调用getUserInfo，避免重复调用
    if (!userStore.userInfo) {
      await userStore.getUserInfo()
    }
    const { value } = binding
    const hasOpList = userStore.userInfo?.permissions
    const AllOpObj = getOpList()
    //permissions返回空数组有所有权限
    let hasPermission = value == "hasPermission" || userStore.userInfo?.is_main

    if (!hasPermission && Array.isArray(value)) {
      // 支持权限数组，HIMI只要满足其中一个权限即可
      hasPermission = value.some((perm) => hasOpList?.find((op) => AllOpObj[op] == perm))
    } else if (!hasPermission) {
      hasPermission = hasOpList?.find((op) => AllOpObj[op] == value) ? true : false
    }
    if (hasPermission) {
      el.style.display = "visible"
    } else {
      el.style.display = "none"
    }
  }
}
